import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function FirmaPage() {
  const [showBooking, setShowBooking] = useState(false);
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-orange-50 to-amber-100 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-quill-pen-fill text-3xl text-white"></i>
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Firma a Distanza
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                La Firma Elettronica Qualificata (FEQ) ha lo stesso identico valore legale di una firma a penna. 
                Semplice, sicura e completamente riconosciuta dalla legge italiana ed europea.
              </p>
              <Button size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
                Inizia Processo di Firma
              </Button>
            </div>
          </div>
        </section>

        {/* Vantaggi Firma Digitale */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Perché Scegliere la Firma Digitale
              </h2>
              <p className="text-xl text-gray-600">
                Tutti i vantaggi della firma digitale per i tuoi contratti di locazione
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-fill text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Valore Legale Pieno</h3>
                <p className="text-gray-600">La firma digitale ha lo stesso valore legale della firma autografa secondo la normativa europea</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-fill text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Velocità e Comodità</h3>
                <p className="text-gray-600">Firma il contratto comodamente da casa tua in pochi minuti, senza appuntamenti fisici</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-lock-fill text-2xl text-green-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Sicurezza Garantita</h3>
                <p className="text-gray-600">Crittografia avanzata e autenticazione forte per proteggere la tua identità e i documenti</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-global-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Conformità Europea</h3>
                <p className="text-gray-600">Rispetta completamente il Regolamento eIDAS e tutte le normative europee sulla firma digitale</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-file-shield-fill text-2xl text-red-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Integrità Documenti</h3>
                <p className="text-gray-600">Garantisce che il documento non possa essere modificato dopo la firma senza invalidarla</p>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-lg text-center">
                <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-smartphone-fill text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Semplicità di Utilizzo</h3>
                <p className="text-gray-600">Ti basta un computer con webcam oppure un tablet/cellulare per firmare comodamente ovunque ti trovi</p>
              </div>
            </div>
          </div>
        </section>

        {/* Come Funziona */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Come Funziona il Processo
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-orange-600 font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Ricezione Documento</h3>
                      <p className="text-gray-600">Ricevi la mail con il link per accedere alla piattaforma di firma</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-orange-600 font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Identificazione Sicura</h3>
                      <p className="text-gray-600">Collegati con webcam per l'identificazione con l'operatore e verifica dei documenti</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-orange-600 font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Ottieni il Certificato</h3>
                      <p className="text-gray-600">Concludi l'identificazione e richiedi il tuo certificato di firma FEQ</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-orange-600 font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Firma Digitale</h3>
                      <p className="text-gray-600">Visualizza il documento e inserisci il codice di sicurezza (OTP) ricevuto via SMS per firmare</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mr-4 mt-1">
                      <span className="text-orange-600 font-bold">5</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Documento Firmato</h3>
                      <p className="text-gray-600">Scarica il documento firmato e la certificazione</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-cover bg-center rounded-xl h-96" style={{
                backgroundImage: `url('/images/firma-detail.jpg')`
              }}></div>
            </div>
          </div>
        </section>

        {/* Tipi di Firma Digitale */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Firma Elettronica Qualificata
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Offriamo esclusivamente la firma elettronica qualificata, il massimo livello di sicurezza e validità legale per i tuoi documenti
              </p>
            </div>

            <div className="max-w-2xl mx-auto">
              <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 shadow-lg border-2 border-teal-500">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center">
                      <i className="ri-shield-check-line text-3xl text-white"></i>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      Firma Elettronica Qualificata (FEQ)
                    </h3>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      La firma elettronica qualificata è l'unica firma digitale che ha lo stesso valore legale della firma autografa tradizionale. Garantisce la massima sicurezza e autenticità del documento.
                    </p>
                    
                    <div className="space-y-3 mb-6">
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">Pieno valore legale equivalente alla firma autografa</span>
                      </div>
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">Certificato digitale rilasciato da ente certificatore accreditato</span>
                      </div>
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">Massima sicurezza con crittografia avanzata</span>
                      </div>
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">Validità riconosciuta in tutta l'Unione Europea</span>
                      </div>
                      <div className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700">Ideale per contratti di locazione e documenti legali</span>
                      </div>
                    </div>

                    <div className="bg-white rounded-lg p-4 border border-teal-200">
                      <div className="flex items-center gap-2 mb-2">
                        <i className="ri-information-line text-teal-600 text-xl"></i>
                        <span className="font-semibold text-gray-900">Perché solo FEQ?</span>
                      </div>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        Per garantire ai nostri clienti la massima tutela legale, offriamo esclusivamente la firma elettronica qualificata. Questo assicura che ogni contratto e documento firmato abbia piena validità legale e sia incontestabile in qualsiasi sede.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Inizia il Processo di Firma Digitale
            </h2>
            <p className="text-xl text-orange-100 mb-8">
              Firma il tuo contratto di locazione in modo sicuro e legale, direttamente online
            </p>
            <Button variant="secondary" size="lg" className="cursor-pointer" onClick={() => setShowBooking(true)}>
              Inizia Ora
            </Button>
          </div>
        </section>
      </main>
      <Footer />
      <BookingCalendar isOpen={showBooking} onClose={() => setShowBooking(false)} />
    </div>
  );
}
